<template>
  <div class="wechat-send">
    <button v-if="share.offer && share.kind === 'invitation'" type="button" class="send-to-friend" @click="overlay = true">{{ t('button-wechat-send-to-friend') }}</button>
    <div v-if="overlay" class="wechat-send-overlay" @click="overlay = false">
      <svg class="arrow" viewBox="0 0 100 120" aria-hidden="true">
        <path d="M14 112 C 22 64, 46 34, 82 18" fill="none" stroke="#fff" stroke-width="6" stroke-linecap="round"/>
        <path d="M58 10 L 88 14 L 74 40" fill="none" stroke="#fff" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <p class="overlay-text">{{ t('wechat-send-overlay') }}</p>
      <p class="overlay-close">{{ t(share.kind === 'game' ? 'wechat-send-overlay-continue' : 'wechat-send-overlay-close') }}</p>
    </div>
  </div>
</template>

<script>
// On a page meant to be sent (extensions.shareSections), inside WeChat: prepares WeChat's card and,
// when the page offers sending, dims the page with an arrow to WeChat's ··· on arrival from the
// create page; an invitation also shows 发给好友, which opens it again (a game doesn't: owner,
// 2026-10-13). docs/plans/2026-10-10-wechat-friend-invitations.md, §3.12.
import { t } from '@/texts';
import { handicapText } from '@/text';
import { prepareCard } from './share';

export default {
  name: 'WeChatSendSection',
  props: { share: { type: Object, required: true } },
  data() {
    return { overlay: false, openedOnArrival: false, savedTitle: document.title };
  },
  computed: {
    card() {
      const s = this.share;
      const desc = s.handicap
        ? t('invitation-share-desc-handicap', { grid: s.grid, handicap: handicapText(s.handicap) })
        : t('invitation-share-desc', { grid: s.grid });
      if (s.kind === 'invitation') {
        return { title: t('invitation-share-title', { name: s.inviter }), desc, path: s.path };
      }
      return { title: t('game-share-title', { name: s.viewer, id: s.id }), desc, path: s.path };
    },
    // Just made on the create page: the guide opens by itself, once (SPEC §4.11).
    openOnArrival() { return !!(this.share.offer && this.share.arrived); },
  },
  watch: {
    card: { handler(c, old) { if (!old || JSON.stringify(c) !== JSON.stringify(old)) prepareCard(c); }, immediate: true },
    openOnArrival: {
      handler(open) {
        if (open && !this.openedOnArrival) { this.openedOnArrival = true; this.overlay = true; }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    document.title = this.savedTitle;
  },
  methods: { t },
};
</script>

<style scoped>
.wechat-send {
  margin: 6px auto;
  max-width: 320px;
  padding: 0 10px;
}

.send-to-friend {
  width: 100%;
  max-width: 260px;
  height: 48px;
  font-size: 18px;
  color: #fff;
  background: #07c160;
  border: none;
  border-radius: 6px;
}

.wechat-send-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  text-align: right;
}

.arrow {
  display: block;
  width: 110px;
  height: 130px;
  margin: 6px 14px 0 auto;
}

.overlay-close {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 40px;
  margin: 0;
  text-align: center;
  font-size: 18px;
  opacity: 0.9;
}

.overlay-text {
  margin: 0 24px;
  font-size: 22px;
  line-height: 1.4;
}
</style>
